<template>
  <div v-show="tableData.length">
    <el-divider class="blue-divider" style="margin-top: 40px; margin-bottom: 40px"/>
    <h4 class="no-margin">Детализация подписей</h4>
    <el-table
        :data="tableData"
        style="width: 100%; margin-top: 30px"
        :span-method="spanMethod"
        :summary-method="getNamesSummaries"
        :show-summary="true"
        :row-class-name="({row})  => row.__rate_name_row ? 'rate-name-row' : ''"
    >
      <el-table-column prop="rateName"/>
      <el-table-column min-width="150px" label="Продукт">
        <template #default="scope">Аренда подписи</template>
      </el-table-column>
      <el-table-column prop="amount" min-width="200px" label="Кол-во подписей"/>
      <el-table-column min-width="100px" label="Цена">
        <template #default="scope">
          {{ formatNumber(scope.row.unitPrice) }}
        </template>
      </el-table-column>
      <el-table-column label="Расходы" min-width="100px">
        <template #default="scope">
          {{ formatNumber(scope.row.spent) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'NamesDetailedReportTable',
  props: ["tableData", "generalStatistics"],
  methods: {
    spanMethod({row, columnIndex}) {
      if (row.__rate_name_row)
        if (columnIndex === 0) return [1, 10]
        else return [0, 0]
    },
    getNamesSummaries() {
      return [
        "Всего", "",
        this.generalStatistics.names.totalNames,
        "",
        this.formatNumber(this.generalStatistics.names.spent || 0)
      ]
    },
  }
}
</script>

<style>
.rate-name-row {
  font-size: 15px;
  font-weight: bold;
  color: #31373a !important;
  /*padding: 20px 40px !important;*/
}

.rate-name-row .el-table__cell {
  padding-top: 40px;
  border-bottom: 1px solid #31373a !important;
}
</style>